import $axios from '~/plugins/axios';

import { Api, Promo } from '~/api';
import { buildModule } from '../utils';
import { Dict, removeKey } from '~/helpers';

const api = $axios as Api;

export default buildModule()
	.withState({
		storedPromos: {} as Dict<Promo>,
	})
	.withGetters({
		storedPromos: state => state.storedPromos,
		byUuid: state => (promoUuid: string): Promo | null => (
			state.storedPromos[promoUuid] ?? null
		),
	})
	.withMutations({
		STORE_PROMO (state, promo: Promo) {
			state.storedPromos = {
				...state.storedPromos,
				[promo.uuid]: promo,
			};
		},
		REMOVE_STORED_PROMO (state, uuid: string) {
			state.storedPromos = removeKey(state.storedPromos, uuid);
		},
	})
	.withActions({
		async get ({ commit }, uuid: string) {
			const { data } = await api.get(`/promo/${ uuid }`);
			commit('STORE_PROMO', data.payload);
		},
	});
